import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const updateOrganizationInvitation = async (campaignId, details) => {
  const apiURL = API_HOST + '/organization_invites/' + campaignId;
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.patch(apiURL,{
      organization_invite:{
        ...details
      }
    },{
      headers: {
      'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
    }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
